export const parseSafely = (raw) => {
    try {
        const result = JSON.parse(raw);
        return result;
    }
    catch (err) {
        return undefined;
    }
};
export const stringifySafely = (value) => {
    try {
        const result = JSON.stringify(value);
        return result;
    }
    catch (err) {
        return undefined;
    }
};
//# sourceMappingURL=parse-safely.js.map